import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ScrollContainer from "react-indiana-drag-scroll";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "xlsx";
import { toLakhs, getBrandOptions } from "../../utils/constants";
function SalesPersonReports() {
  const [data, setData] = useState([]);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/sales_reports/salesreports",
        method: "POST",
        responseType: "json",
        data: {
          newspaper: selectedNewspaper,
          month: selectedMonth,
          type: selectedType,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if (res.data.userType !== -1) {
          setSelectedType(`${res.data.userType}`);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      const headers = [
        ` Sales Person`,
        `Category`,
        `Region`,
        `No. of meetings`,
        `Active on W2N`,
        `Active on {selectedNewspaper}`,
        `Missing on W2N(Brands)`,
        `Missing Campaigns`,
        `Known`,
        `Unknown`,
        `Conversion`,
        `Target this month`,
        `Revenue this month`,
        `Achieved%`,
      ];

      const rows = [];
      data?.data?.forEach((item) => {
        const achievedPercentage =
          item.target > 0 && item.sum > 0
            ? ((item.sum / item.target) * 100).toFixed(2)
            : "0.00";
          let missingBrands = getMissingCount(item.newspaper_brands, item.w2n_brands);
        rows.push([
          item.name,
          item.category,
          item.region,
          item.meetings || 0,
          item.w2n_clients || 0,
          item.clients || 0,
          missingBrands,
          item.missed,
          item.ki,
          item.ui,
          item.clients
            ? (
                ((item.clients - missingBrands) / item.clients) *
                100
              ).toFixed(2)
            : item.w2n_clients
            ? "100.00"
            : 0,
          item.target,
          item.sum,
          achievedPercentage,
        ]);
      });
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "sales person reports");
      XLSX.writeFile(workbook, `salespersonsreports.xlsx`);
    } catch (error) {
      console.error(error, "sales person reports");
    } finally {
      setDownloadLoader(false);
    }
  };
  useEffect(() => {
    fetchNewspapers();
  }, []);

  const getMissingCount = (paperBrands = [], w2nBrands = []) => {
    const w2nSet = new Set(w2nBrands);
    return paperBrands.filter((brand) => !w2nSet.has(brand)).length;
  };

  useEffect(() => {
    fetchData();
  }, [selectedType, selectedNewspaper, selectedMonth]);

  const handleMonthChange = (date) => {
    setSelectedMonth(date);
  };
  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>Sales Person Reports</h5>
        <aside className="flex gap-3 items-center">
          <SlSelect
            size="small"
            value={selectedType}
            label="Team"
            onSlChange={(e) => {
              setSelectedType(e.target.value);
            }}
          >
            {data?.userType === -1 ? (
              <SlOption value="all">All</SlOption>
            ) : null}
            {getBrandOptions(
              data?.userType,
              localStorage.getItem("email")
            )?.map((type) => (
              <SlOption key={type.value} value={type.value}>
                {type.label}
              </SlOption>
            ))}
          </SlSelect>
          <SlSelect
            label="Newspaper"
            size="small"
            value={selectedNewspaper}
            onSlChange={(e) => setSelectedNewspaper(e.target.value)}
          >
            {newspapers.map((paper) => (
              <SlOption value={paper.name}>{paper.name}</SlOption>
            ))}
          </SlSelect>
          <div className="clientwiserevenue-datepicker max-w-[200px] ">
            <label className="form-label">Select Month</label>
            <DatePicker
              selected={selectedMonth}
              onChange={handleMonthChange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="dateChooser border h-5 rounded-md"
            />
          </div>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
        </aside>
      </div>
      <ScrollContainer>
        <table className="table table-bordered tbodyscroll">
          <thead className="bg-yellow-300">
            <tr>
              <th>Sales Person</th>
              <th>Category</th>
              <th>Region</th>
              <th>No. of meetings</th>
              <th>Active on W2N</th>
              <th>Active on {selectedNewspaper}</th>
              <th>Missing Brands</th>
              <th>Missing Campaigns</th>
              <th>Known Campaigns</th>
              <th>Unknown Campaigns</th>
              <th>Conversion</th>
              <th>Target this month</th>
              <th>Revenue this month</th>
              <th>Achieved %</th>
            </tr>
          </thead>
          {!loader && data?.data?.length > 0 ? (
            <tbody>
              {data?.data
                ?.filter((item) => item.name) // Only include items where name exists
                .map((item, index) => {
                  const achievedPercentage =
                    item.target > 0 && item.sum > 0
                      ? ((item.sum / item.target) * 100).toFixed(2)
                      : "0.00";
                  let missingBrands = getMissingCount(
                    item.newspaper_brands,
                    item.w2n_brands
                  );
                  return (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.category || "N/A"}</td>
                      <td>{item.region || "N/A"}</td>
                      <td>{item.meetings || 0}</td>
                      <td>{item.w2n_clients || 0}</td>
                      <td>{item.clients || 0}</td>
                      <td>{missingBrands}</td>
                      <td>{item.missed || 0}</td>
                      <td>{item.ki || 0}</td>
                      <td>{item.ui || 0}</td>
                      <td>
                        {item.clients
                          ? (
                              ((item.clients - missingBrands) / item.clients) *
                              100
                            ).toFixed(2)
                          : item.w2n_clients
                          ? "100.00"
                          : 0}
                        %
                      </td>
                      <td>{toLakhs(item.target || 0)}</td>
                      <td>{toLakhs(item.sum || 0)}</td>
                      <td>{achievedPercentage}%</td>
                    </tr>
                  );
                })}

              {/* Total Row */}
              <tr className="font-bold bg-gray-200">
                <td>Total</td>
                <td></td>
                <td></td>
                <td>
                  {data?.data?.reduce(
                    (acc, item) => acc + (+item.meetings || 0),
                    0
                  )}
                </td>
                <td>
                  {data?.data?.reduce(
                    (acc, item) => acc + (+item.w2n_clients || 0),
                    0
                  )}
                </td>
                <td>
                  {data?.data?.reduce(
                    (acc, item) => acc + (+item.clients || 0),
                    0
                  )}
                </td>
                <td>
                  {data?.data?.reduce(
                    (acc, item) =>
                      acc +
                      getMissingCount(item.newspaper_brands, item.w2n_brands),
                    0
                  )}
                </td>
                <td>
                  {data?.data?.reduce((acc, item) => acc + (+item.missed || 0), 0)}
                </td>
                <td>
                  {data?.data?.reduce((acc, item) => acc + (+item.ki || 0), 0)}
                </td>
                <td>
                  {data?.data?.reduce((acc, item) => acc + (+item.ui || 0), 0)}
                </td>
                <td>
                  {(() => {
                    const totalClients = data?.data?.reduce(
                      (acc, item) => acc + (+item.clients || 0),
                      0
                    );
                    const totalMissingCount = data?.data?.reduce(
                      (acc, item) =>
                        acc +
                        (getMissingCount(
                          item.newspaper_brands,
                          item.w2n_brands
                        ) || 0),
                      0
                    );

                    return totalClients > 0
                      ? (
                          ((totalClients - totalMissingCount) / totalClients) *
                          100
                        ).toFixed(2) + "%"// Ensures only 2 decimal places
                      : "N/A"; // Avoids division by zero or NaN
                  })()}
                </td>
                <td>
                  {toLakhs(
                    data?.data?.reduce(
                      (acc, item) => acc + (+item.target || 0),
                      0
                    )
                  )}
                </td>
                <td>
                  {toLakhs(
                    data?.data?.reduce((acc, item) => acc + (+item.sum || 0), 0)
                  )}
                </td>
                <td>
                  {(() => {
                    const target = data?.data?.reduce(
                      (acc, item) => acc + (+item.target || 0),
                      0
                    ); // Sum of all target values

                    const achieved = data?.data?.reduce(
                      (acc, item) => acc + (+item.sum || 0),
                      0
                    ); // Sum of all achieved revenue

                    return target > 0
                      ? ((achieved / target) * 100).toFixed(2) + "%" // Calculate % only if target > 0
                      : "0.00%"; // Avoid division by zero
                  })()}
                </td>
              </tr>
            </tbody>
          ) : loader ? (
            <TableSkelton rowSpan={15} colspan={13} />
          ) : (
            <NoDataFound colspan={13} />
          )}
        </table>
      </ScrollContainer>
    </>
  );
}

export default SalesPersonReports;
